import { memo, useState } from 'react'
import { useI18n } from '@muse/i18n'
import { useLocation } from '@muse-web/router'
import { AsyncNavigation } from '../components/navigation'
import { SeoNav } from '../components/seo-nav'
import { MAIN_NAV_LABEL, SEO_NAV, SEO_NAV_LABEL } from '../constants/navigation'
import { buildNavEntries } from '../helpers/buildNavEntries'
import { markActiveNavEntries } from '../helpers/markActiveNavEntries'

export const NavigationContainer = memo(() => {
    const { t } = useI18n()
    const { pathname } = useLocation()
    const [documentPathname] = useState(pathname)

    const entries = buildNavEntries(t, 'header')

    return (
        <>
            <AsyncNavigation
                navEntries={markActiveNavEntries(entries, pathname)}
                serverNavEntries={markActiveNavEntries(entries, documentPathname)}
                newLabel={t('i18n.headerNew')}
                label={MAIN_NAV_LABEL}
            />
            <SeoNav label={SEO_NAV_LABEL} entries={SEO_NAV} />
        </>
    )
})
